import { useEffect } from 'react';

import { RULES_COMPETE_URL_STORAGE_KEY } from '../../constants';
import { Stack } from '../../components/UI';
import { useSessionStorageTransfer } from '../../hooks';

import type { RulesRedirectPageProps } from './RulesRedirectPage.types';

export const RulesRedirectPage = (props: RulesRedirectPageProps) => {
    const { redirectUrl } = props;

    const { value: rulesUrl } = useSessionStorageTransfer(RULES_COMPETE_URL_STORAGE_KEY);

    // Приоритет: URL из state (динамический из БД) > URL из пропсов (статический)
    const finalRedirectUrl = rulesUrl || redirectUrl;

    useEffect(() => {
        window.location.href = finalRedirectUrl;
    }, [finalRedirectUrl]);

    return (
        <Stack
            justifyContent="center"
            alignItems="center"
            style={{
                height: '100vh',
                fontSize: '18px',
                color: '#666',
            }}
        >
            Открываем правила...
        </Stack>
    );
};
